import { PreviewDeatisData, ProjectAPICommercialsForm } from "@redux/reducers/apiCommercialReducer";

export enum ActionType {
  API_COMMERCIAL_DETAIL_BY_PID = "API_COMMERCIAL_DETAIL_BY_PID",
  API_COMMERCIAL_PREVIEW_DETAILS_DATA = "API_COMMERCIAL_PREVIEW_DETAILS_DATA",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}
export interface IAPICommercialByPid {
  type: ActionType.API_COMMERCIAL_DETAIL_BY_PID;
  payload: ProjectAPICommercialsForm[];
}
export interface IAPICommercialPreviewDetailsData {
  type: ActionType.API_COMMERCIAL_PREVIEW_DETAILS_DATA;
  payload: PreviewDeatisData[];
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IAPICommercialByPid | IAPICommercialPreviewDetailsData | IResetReduxState;
